export default __webpack_public_path__ + "static/media/b14-thumb.79e05f65.jpg";